export default __webpack_public_path__ + "static/media/shopping_cart.298effb1.svg";